import styled from 'styled-components';
import { desktop1024, tablet768 } from '@nubank/nuds-web/styles/breakpoints';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import addWebpBackgroundImage from 'styles/addWebpBackgroundImage';

export const DefaultContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${nuDSColor('primary')};
  background-size: cover;
  background-position: center;
  position: relative;

  ${tablet768`
    padding: 4rem;
    align-items: center;
    ${addWebpBackgroundImage('woman-holding-card-smiling/woman-holding-card-smiling@1x.jpg')}
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
  `}

  ${desktop1024`
    flex-direction: row;
    ${addWebpBackgroundImage('woman-holding-card-smiling/woman-holding-card-smiling@3x.jpg')}
    background-size: cover;
    background-position: center bottom;
    align-items: flex-start;
  `}
`;

DefaultContainer.displayName = 'DefaultContainer';
